import { useApiClient } from '@/composables/useApiClient'

import type { ICreateNote } from './interfaces/create-note.interface'
import type { IGetNotesResponse } from './interfaces/get-notes-response.interface'
import type { INote } from './interfaces/note.interface'
import type { IUpdateNote } from './interfaces/update-note.interface'

export const useNoteServices = () => {
  const privateApi = useApiClient(true)

  const createNote = async (data: ICreateNote) => {
    return privateApi.post<INote, ICreateNote>('/notes', data)
  }

  const getNotes = async () => {
    return privateApi.get<IGetNotesResponse>('/notes')
  }

  const updateNote = async (noteId: string, data: IUpdateNote) => {
    return privateApi.patch<INote, IUpdateNote>(`/notes/${noteId}`, data)
  }

  const deleteNote = async (noteId: string) => {
    return privateApi.delete<void>(`/notes/${noteId}`)
  }

  return {
    createNote,
    getNotes,
    updateNote,
    deleteNote,
  }
}
